export default __webpack_public_path__ + "static/media/no-payment.f2dc6bec.svg";